<template>
<div class="chapter">
<div class="inner_page">
<div class="titleplage">
<p class="immagine3"><span>Seth Greenland</span></p>
<p class="immagine4"><span>I REGRET EVERYTHING</span></p>
<div class="immagine"><img alt="" height="92" src="Images/logo.jpg" width="98"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Titlepage.vue?ddf4a51e